import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import firebase from "firebase/app";
import "firebase/analytics";
var firebaseConfig = {
  apiKey: "AIzaSyCNQn_QRz6guDOcw00RX3gAPYV3Whgfr74",
  authDomain: "wherecaniseefuji.firebaseapp.com",
  projectId: "wherecaniseefuji",
  storageBucket: "wherecaniseefuji.appspot.com",
  messagingSenderId: "6916687110",
  appId: "1:6916687110:web:5a9c3325cebd3f62058a87",
  measurementId: "G-M554HJ1TYF"
};
if (firebase.apps.length === 0) {
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
